import styled from 'styled-components';

export const SurveyView = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #E9E9F5;
  align-items: center;
  .toolbar {
    margin-top: 20px;
    border: 2px solid #FFFFFF;
    border-radius: 20px;
    padding: 10px;
    width: 90%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    &__left {
      display: flex;
      align-items: center;
      .back-button {
        background-color: #FFFFFF;
        display: flex;
        height: 36px;
        width: 36px;
        border-radius: 14px;
        border: none;
        outline: none;
        margin-right: 10px;
        cursor: pointer;
        &__icon {
          font-size: 9px;
          color: #36369B;
          margin: auto;
        }
      }
      .survey-info {
        font-family: Nunito Sans Light;
        font-size: 24px;
        color: #3E3E5B;
      }
    }
    &__right {
      align-self: center;
      .select-container {
        display: flex;
        align-items: center;
        &__label {
          font-family: Nunito Sans Bold;
          font-size: 15px;
          margin-right: 10px;
          white-space: nowrap;
          color: #1F1F52;
        }
      }
    }
  }

  .section {
    border-bottom: 2px solid #FFFFFF;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    &__content {
      width: 90%; 
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 10px 0;
    }
    .survey-process {
      font-family: Nunito Sans;
      font-size: 17px;
      color: #3E3E5B;
    }
  }

  .surveys-section {
    display: flex;
    flex-direction: column;
    height: calc(100% - 174px);
    width: 90%;
    padding: 13px 0 33px 0;
  }
  .survey-list {
    border: 2px solid var(--base-White-I, #FFFFFF);
    background-color: #F2F2F7;
    height: 100%;
    box-shadow: 0px 3px 9.5px 1px #9395CC24;
    overflow: auto;
    width: 100%;
    border-radius: 20px;
    padding: 10px 20px;
  }
  .survey-table {
    width: 100%;
    box-sizing: border-box;
    &--reaction {
      margin: auto;
    }
    table {
      width: 100%;
      border-collapse: collapse;
      th {
        padding: 11.5px 20px;
        text-align: start;
        color: #707582;
        font-family: Nunito Sans Light;
        font-size: 14px;
        border-bottom: 1px solid #CFD3DD;
      }
      td {
        padding: 30px 20px 20px;
      }
    }
  }
`